module.exports = __webpack_public_path__ + "img/86.67e2da09.png";